import ArmorClassBoxSvg from "./ArmorClassBoxSvg";

export default ArmorClassBoxSvg;
export { ArmorClassBoxSvg };
